export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4789.2bf16526.jpg";